import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { changeIframeOnClick } from '../../../../../../../helper/Helpers';

function BottomBar_5({ item }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  const [activeBottomBar, setActiveBottomBar] = useState(0);
  const bottomBarFilter = useMemo(() => HexToHueConverter(customization?.iconColor), [customization?.iconColor]);
  const bottomBarFilterActive = useMemo(
    () => HexToHueConverter(customization?.selectedIconColor),
    [customization?.selectedIconColor],
  );
  const bottomBarFilterStatic = useMemo(
    () => HexToHueConverter(customization?.staticIconColor),
    [customization?.staticIconColor],
  );

  return (
    <div
      className="w-full  px-4 "
      id="bottomBar"
      style={{
        backgroundColor: customization?.backgroundColor,
        borderBottomRightRadius: customization?.bottomRadius,
        borderBottomLeftRadius: customization?.bottomRadius,
        display: 'flex',
        justifyContent: 'space-around',
        height: staticValues[35]
      }}
    >
      {customization?.items?.map((bottomBarItem, index) => {
        return (
          <div
            class="flex cursor-pointer  z-[20]"
            style={{
              flexShrink: index === 2 ? 1 : 0,
              flexDirection: 'column-reverse',
              maxWidth: '30%',
              alignItems: 'center',
              paddingTop: staticValues[5],
              gap: staticValues[5],
              position: index === 2 && 'relative',
              top: -`${staticValues[30]}`,
              justifyContent: 'flex-end',
            }}
            onClick={() => {
              changeIframeOnClick(bottomBarItem?.pointTo?.pointTo)
              setActiveBottomBar(index);
            }}
          >
            <div
              style={{
                borderRadius: '50%',
                border: staticValues[5] + 'px solid ' + (index === 2 && customization?.backgroundColor),
                padding: index === 2 ? staticValues[13] : staticValues[10],
                background: index === 2 && customization?.staticBackgroundColor,
              }}
            >
              <img
                style={{
                  filter:
                    index === 2
                      ? bottomBarFilterStatic
                      : activeBottomBar === index
                        ? bottomBarFilterActive
                        : bottomBarFilter,
                }}
                className={`${index === 2 ? 'w-[22px] h-[22px]' : 'w-[20px] h-[20px]'} `}
                src={bottomBarItem?.url}
                alt={'bottom bar icon'}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
export default BottomBar_5;
